<template>
  <div class="content-hero-section" id="layout">
    <img src="@/assets/reggenius.jpeg" alt="" />
    <div class="content-section-container">
      <div class="container">
        <nav>
          <a href="/">
            <div class="icon">
              <p>Reggenius</p>
              <div class="img-container">
                <img src="@/assets/reggenius.jpeg" alt="reginald logo" />
              </div>
            </div>
          </a>
          <div class="navigations">
            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/in/reggenius"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fa-brands fa-linkedin-in"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@reggenius"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </li>
              <li>
                <a
                  href="mailto:reginaldchikelu@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fa fa-envelope"></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <!-- Corner styling boxes -->
        <div class="corners top-left"></div>
        <div class="corners bottom-right"></div>

        <div class="two-column">
          <div class="col-left">
            <h1 :id="headingId">
              <slot name="heading">
                <span>W</span><span>e</span><span>l</span><span>c</span
                ><span>o</span><span>m</span><span>e</span><span>!</span>
              </slot>
            </h1>
            <p>
              <span :id="paraId">{{ para1 }}</span>
              <br /><br />
              <span v-html="para2"></span>
            </p>
            <slot name="links"></slot>
          </div>
          <div class="col-right">
            <h2>Projects</h2>
            <ul v-if="!isIndex">
              <li v-for="(project, key) in projects" :key="key">
                <a
                  href="javascript:void(0)"
                  :id="isViewed(key, projViewed)"
                  @click="$emit('nextProject', key)"
                  >{{ project.heading }}</a
                >
              </li>
            </ul>
            <ul v-else>
              <li>
                <a href="#" @click="viewProject('mini')">Mini</a>
              </li>
              <li>
                <a href="#" @click="viewProject('mega')">Mega</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="copyright">
          <p>© 2024 Reggenius</p>
          <div class="img-container">
            <img src="@/assets/reggenius.jpeg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onBeforeMount, onUnmounted } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

defineProps({
  paraId: {
    type: String,
    default: null,
  },
  para1: {
    type: String,
    default:
      "I am Reginald Chikelu, a passionate Full-Stack Software Engineer who loves turning ideas into sleek, functional and scalable digital experiences.",
  },
  para2: {
    type: String,
    default: `I build everything from intuitive front-end interfaces to powerful back-end systems that keep things running smoothly behind the scenes. Lately, I've been exploring ways to integrate Artificial Intelligence into the applications I build. <br><br>For me, every project is a chance to learn, collaborate and innovate. So <a href="mailto:reginaldchikelu@gmail.com" style="text-decoration: underline; text-underline-offset: 2.5px;">reach out</a> now let's build something impactful together.`,
  },
  headingId: {
    type: String,
    default: "",
  },
  isIndex: {
    type: Boolean,
    default: true,
  },
  projects: {
    type: Object,
  },
  projViewed: {
    type: String,
  },
});

//  Check the current project under view
//  so as to know which onne to highlight in the list
const isViewed = (projName, projInView) => {
  if (projName === projInView) return projInView;
  else return "";
};

const viewProject = (group) => {
  router.push({ name: "projects", query: { group } });
};

onBeforeMount(() => {
  const bodyEl = document.querySelector(" body");
  bodyEl.classList.add("reggie-body");
});

onUnmounted(() => {
  const bodyEl = document.querySelector(" body");
  bodyEl.classList.remove("reggie-body");
});
</script>

<style>
.reggie-body,
.reggie-body #app {
  background-color: black;
  color: white;
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

a:hover {
  color: #e05414;
}

p,
h1,
h2 {
  margin: 0;
}

#layout.content-hero-section {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Anek Telugu", "sans-serif";
  background-color: black;
  position: relative;
  overflow: hidden;
  animation: scaleOut 2s linear forwards alternate;
}

#layout.content-hero-section > img {
  position: absolute;
  opacity: 0.1;
}

#layout .content-section-container {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

#layout .container {
  width: 100%;
  max-width: 1100px;
  box-sizing: border-box;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

#layout .container nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  box-sizing: border-box;
}

#layout .container nav > a:hover {
  color: white;
}

#layout.content-hero-section .container .icon {
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

#layout.content-hero-section .container .icon:hover {
  cursor: pointer;
}

#layout.content-hero-section .icon p {
  width: fit-content;
  position: relative;
  z-index: 1;
  background-color: black;
  font-weight: 800;
  text-shadow: -2px -1px 1px #292828;
  line-height: 10px;
  letter-spacing: 0.5px;
}

#layout.content-hero-section nav .img-container {
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid white;
  position: absolute;
  z-index: 0;
  background-color: black;
}

#layout.content-hero-section nav .img-container img {
  width: 88.9px;
  height: 50px;
}

#layout.content-hero-section .navigations {
  width: 150px;
}

#layout.content-hero-section .navigations ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

#layout.content-hero-section .navigations li {
  list-style: none;
  transition: transform 1s ease;
}

#layout.content-hero-section.navigations li:hover {
  transform: rotate(360deg);
}

#layout.content-hero-section .navigations li a {
  font-size: 21px;
  transition: transform 1s ease;
}

#layout.content-hero-section .navigations li a:hover {
  color: #e05414;
}

#layout .container .corners {
  width: 280px;
  height: 280px;
  position: absolute;
  background-color: grey;
}

#layout .container .corners.top-left {
  top: 0;
  left: 0;
  clip-path: polygon(0 0, 100% 0, 96% 3.5%, 3.5% 3.5%, 3.5% 96%, 0 100%);
}

#layout .container .corners.bottom-right {
  right: 0;
  bottom: 0;
  clip-path: polygon(100% 0, 96% 3.5%, 96% 96%, 3.5% 96%, 0 100%, 100% 100%);
}

#layout .container .two-column {
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 90px;
  box-sizing: border-box;
  margin-top: 100px;
}

/* ANIMATION STARTS */

#layout .container .col-left h1 {
  font-size: 40px;
}

#layout .container .col-left h1 {
  color: hsl(0, 0%, 28%);
  font-size: 50px;
  font-weight: bold;
  font-family: monospace;
  letter-spacing: 7px;
  margin-bottom: 30px;
  width: fit-content;
}

#layout .container .col-left h1 span {
  transition: 0.5s ease-out;
}
#layout .container:hover .col-left h1 span:nth-child(1) {
  margin-right: 5px;
}
#layout .container:hover .col-left h1 span:nth-child(2) {
  margin-right: 5px;
}
#layout .container:hover .col-left h1 span:nth-child(3) {
  margin-right: 5px;
}
#layout .container:hover .col-left h1 span:nth-child(4) {
  margin-right: 5px;
}

#layout .container:hover .col-left h1 span:nth-child(5) {
  margin-left: 5px;
}
#layout .container:hover .col-left h1 span:nth-child(6) {
  margin-left: 5px;
}
#layout .container:hover .col-left h1 span:nth-child(7) {
  margin-left: 5px;
}
#layout .container:hover .col-left h1 span:nth-child(8) {
  margin-left: 5px;
}

#layout .container:hover .col-left h1 span {
  color: #fff;
  text-shadow:
    0 0 10px #fff,
    0 0 20px #fff,
    0 0 40px #fff;
}

/* ANIMATION ENDS */

#headingId {
  font-size: 35px;
  letter-spacing: 1px;
  margin-bottom: 25px;
  position: relative;
  display: flex;
  width: fit-content;
}

#headingId i {
  text-transform: capitalize;
}

#headingId i:hover {
  cursor: pointer;
}

#headingId i:nth-of-type(1) {
  position: relative;
  z-index: 2;
  color: #e05414;
}

#headingId .img-container {
  padding-left: 15px;
  opacity: 1;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

#headingId img {
  height: 20px;
  transition: all 0.3s linear;
}

#headingId .img-container:hover {
  cursor: pointer;
}

#headingId .img-container::after {
  content: "";
  width: 20px;
  height: 20px;
  background-color: black;
  opacity: 0.5;
  position: absolute;
  z-index: 3;
}

#switch {
  position: absolute;
  overflow: hidden;
  height: 0px;
  z-index: 1;
  opacity: 0;
  top: 5px;
  right: 13px;
  color: #c9c5c5;
  padding: 10px;
  box-shadow: 0px 0px 5px rgb(141, 140, 140);
  transition: all 0.3s linear;
}

#switch.make-visible {
  height: fit-content;
  top: 45px;
  opacity: 1;
}

#switch:hover {
  color: #e05414;
}

#layout .container .col-left p {
  font-size: 16.5px;
  letter-spacing: 0.5px;
  text-align: justify;
}

#proj-name {
  font-weight: 800;
  font-size: 20px;
  position: absolute;
  color: transparent;
  background-image: linear-gradient(90deg, #ff8a00, #c8305f);
  -webkit-background-clip: text;
  background-clip: text;
  opacity: 0;
  animation: scale 4s cubic-bezier(0.5, -0.75, 0.7, 1.25) forwards;
}

#layout .container .col-left p span {
  font-weight: 500;
}

#project-links {
  margin-top: 10px;
  font-weight: 300;
}

#project-links a {
  margin-right: 20px;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-bottom: 2px;
  border-bottom-style: solid;
  color: #c0bab8;
}

#project-links a:hover {
  color: #e05414;
}

#layout .container .col-right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

#layout .container h2 {
  letter-spacing: 0.5px;
}

#layout .container .col-right ul {
  padding: 0;
  margin: 20px 0;
}

#layout .container .col-right ul li {
  list-style: none;
  font-size: 18px;
  padding: 10px 0;
  text-transform: capitalize;
}

.col-right a {
  font-weight: 500;
}

#grid,
#artist,
#blog,
#cost,
#hazel,
#swipe,
#coach,
#vidly,
#salary,
#portfolio {
  color: #e05414;
}

#layout .container .copyright {
  display: flex;
  align-self: flex-end;
  font-size: 13px;
}

#layout .container .copyright .img-container {
  margin-left: 6px;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid white;
}

#layout .container .copyright .img-container img {
  width: 26.68px;
  height: 15px;
}

/* -------------------------------------------MEDIA QUERIES------------------------------------------- */
/* ----------------------------- FIRST BREAKPOINT ------------------------------- */
@media only screen and (min-width: 1200px) and (min-height: 730px) {
  #layout.content-hero-section {
    height: 100vh;
    max-height: 1384px;
  }
}

/* ----------------------------- SECOND BREAKPOINT ------------------------------- */
@media only screen and (max-width: 1040px) {
  #layout .container .two-column {
    grid-template-columns: 2.5fr 1fr;
    column-gap: 70px;
  }
}

/* ----------------------------- THIRD BREAKPOINT ------------------------------- */
@media only screen and (max-width: 1000px) {
  #layout.content-hero-section {
    align-items: flex-start;
  }

  #layout.content-hero-section > img {
    width: 1000px;
    height: 562.25px;
  }

  #layout .container {
    border-radius: 0;
  }

  #layout .container .corners.top-left {
    clip-path: polygon(0 0, 100% 0, 97.5% 2.5%, 2.5% 2.5%, 2.5% 97.5%, 0 100%);
  }

  #layout .container .corners.bottom-right {
    clip-path: polygon(
      100% 0,
      97.5% 2.5%,
      97.5% 97.5%,
      2.5% 97.5%,
      0 100%,
      100% 100%
    );
  }
}

/* ----------------------------- FOURTH BREAKPOINT ------------------------------- */
@media only screen and (max-width: 966px) {
  #layout .container .col-left h1 {
    font-size: 45px;
    letter-spacing: 2px;
  }
}

/* ----------------------------- SIXTH BREAKPOINT ------------------------------- */
@media only screen and (max-width: 840px) {
  h2 {
    font-size: 20px;
  }

  #headingId {
    font-size: 27px;
  }

  #layout.content-hero-section > img {
    width: 840px;
    height: 472.269px;
  }
  #layout.content-hero-section .icon p {
    font-size: 12px;
    line-height: 7px;
  }

  #layout.content-hero-section nav .img-container {
    width: 45px;
    height: 45px;
  }

  #layout.content-hero-section nav .img-container img {
    width: 80px;
    height: 45px;
  }

  #proj-name {
    font-size: 18px;
  }

  #layout .container .col-right ul li {
    font-size: 16px;
  }

  #layout.content-hero-section .navigations li a {
    font-size: 17px;
  }
  #layout .container .col-left h1 {
    font-size: 35px;
  }

  #layout .container .col-left p {
    font-size: 14px;
  }

  #layout .container .copyright {
    font-size: 11.5px;
  }

  #layout .container .copyright .img-container {
    width: 13px;
    height: 13px;
  }
}

/* ----------------------------- SEVENTH BREAKPOINT ------------------------------- */
@media only screen and (max-width: 748px) {
  h2 {
    font-size: 18px;
  }

  #switch.make-visible {
    top: 35px;
  }

  #layout .container .two-column {
    grid-template-columns: 1fr;
    grid-template-areas:
      "a"
      "b";
    row-gap: 40px;
    margin-top: 80px;
  }

  #layout .container .col-right {
    grid-area: a;
  }

  #layout .container .col-right ul li {
    font-size: 15px;
  }

  #layout .container .col-left {
    grid-area: b;
  }

  #layout .container .col-right ul {
    margin: 0;
    margin-top: 5px;
  }

  #layout .container .col-right ul li {
    padding: 5px 0;
  }
}

/* ----------------------------- EIGHT BREAKPOINT ------------------------------- */
@media only screen and (max-width: 480px) {
  #layout .container {
    padding: 10px;
  }

  #layout.content-hero-section > img {
    width: 711.458px;
    height: 400px;
  }

  #layout.content-hero-section .icon p {
    font-size: 10.5px;
  }

  #layout .container .corners {
    display: none;
  }

  #layout.content-hero-section nav .img-container {
    width: 40px;
    height: 40px;
  }

  #layout.content-hero-section nav .img-container img {
    width: 71.146px;
    height: 40px;
  }

  #layout .container .two-column {
    margin-top: 50px;
  }

  #layout .container .col-left h1 {
    font-size: 30px;
    letter-spacing: 3px;
  }

  #headingId {
    font-size: 24px;
    letter-spacing: 0;
  }

  #proj-name {
    font-size: 16.5px;
  }

  #layout.content-hero-section .navigations {
    width: 120px;
  }

  #layout.content-hero-section .navigations li a {
    font-size: 15px;
  }

  #layout .container:hover .col-left h1 span:nth-child(1),
  #layout .container:hover .col-left h1 span:nth-child(2),
  #layout .container:hover .col-left h1 span:nth-child(3),
  #layout .container:hover .col-left h1 span:nth-child(4) {
    margin-right: 3px;
  }

  #layout .container:hover .col-left h1 span:nth-child(5),
  #layout .container:hover .col-left h1 span:nth-child(6),
  #layout .container:hover .col-left h1 span:nth-child(7),
  #layout .container:hover .col-left h1 span:nth-child(8) {
    margin-left: 3px;
  }

  #project-links {
    font-size: 14px;
  }

  #project-links a {
    font-weight: 600;
  }

  #layout .container .copyright {
    margin-top: 40px;
  }
}

/* PROJECT NAME ANIMATION */
@keyframes scale {
  0% {
    opacity: 0.5;
    transform: scale(10);
    filter: blur(10px);
  }
  50%,
  85% {
    opacity: 0.8;
    transform: scale(2.7);
    margin-left: 50px;
    filter: blur(0px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0px);
  }
}
</style>
